<template>
    <gz-auth-view-template :bc="false">
    <GZ-StaticNotification slot="notification"/>
            
        <section slot="above-content" class="gz-tabs gz-tabs__section">
            <router-link 
                to="/admin/users/users-list" 
                class="gz-tabs__item"
            >Список пользователей</router-link>
        </section>

        <section slot="content">
            <router-view></router-view>
        </section>        
    </gz-auth-view-template>
</template>

<script>
export default {
    name: 'AdminUsersView'
}
</script>